import React, { useEffect, useState } from 'react';
import {
  Container,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Alert,
  Box,
  CircularProgress,
} from '@mui/material';
import { fetchApi } from './fetchApi';

interface ArtikelUnterMindestbestand {
  artikel_id: number;
  sku: string;
  bezeichnung: string;
  gesamtmenge: number;
  mindestbestand: number;
}

export default function ArtikelUnterMindestbestandTabelle() {
  const [daten, setDaten] = useState<ArtikelUnterMindestbestand[]>([]);
  const [fehler, setFehler] = useState<string | null>(null);
  const [laedt, setLaedt] = useState(true);

  useEffect(() => {
    fetchApi('/api/view/artikel-unter-mindestbestand')
      .then((res) => {
        if (!res.ok) throw new Error(String(res.status));
        return res.json();
      })
      .then((rows: ArtikelUnterMindestbestand[]) => setDaten(Array.isArray(rows) ? rows : []))
      .catch((err: any) => {
        setFehler(
          err?.message === '401'
            ? 'Session abgelaufen. Bitte neu einloggen.'
            : 'Daten konnten nicht geladen werden.'
        );
        setDaten([]);
      })
      .finally(() => setLaedt(false));
  }, []);

  return (
    <Container maxWidth="md">
      <Box mt={4} mb={2}>
        <Typography variant="h5">Artikel unter Mindestbestand</Typography>
      </Box>

      {fehler && <Alert severity="error">{fehler}</Alert>}

      {laedt ? (
        <Box display="flex" justifyContent="center" mt={4}>
          <CircularProgress />
        </Box>
      ) : (
        <Paper>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>SKU</TableCell>
                <TableCell>Bezeichnung</TableCell>
                <TableCell align="right">Gesamtmenge</TableCell>
                <TableCell align="right">Mindestbestand</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {daten.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={4} align="center" sx={{ opacity: 0.7 }}>
                    Alle Artikel über Mindestbestand.
                  </TableCell>
                </TableRow>
              ) : (
                daten.map((a) => (
                  <TableRow key={a.artikel_id}>
                    <TableCell>{a.sku}</TableCell>
                    <TableCell>{a.bezeichnung}</TableCell>
                    <TableCell align="right" sx={{ color: 'error.main', fontWeight: 600 }}>
                      {a.gesamtmenge}
                    </TableCell>
                    <TableCell align="right">{a.mindestbestand}</TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </Paper>
      )}
    </Container>
  );
}
